
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.729","height":"11.363"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1794"}},[_c('g',{attrs:{"data-name":"그룹 1792","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"선 704","d":"M1.365 5.364l7-4"}}),_c('path',{attrs:{"data-name":"선 705","d":"M15.365 5.364l-7-4"}})]),_c('g',{attrs:{"data-name":"그룹 1793"}},[_c('path',{attrs:{"data-name":"패스 1163","d":"M5.365 9.362a2 2 0 11-2-2 2 2 0 012 2z"}}),_c('path',{attrs:{"data-name":"패스 1164","d":"M10.365 9.362a2 2 0 11-2-2 2 2 0 012 2z"}}),_c('path',{attrs:{"data-name":"패스 1165","d":"M15.365 9.362a2 2 0 11-2-2 2 2 0 012 2z"}})])])])
          )
        }
      }
    